import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonTooltipV3 } from '../Tooltip/Tooltip.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTooltipV3({ prefix }));
}
